<template>

<m-mobile-autocomplete
    :value="internal_value"
    :items="items"
    :search="doSearch"
    v-on:input="onInput"
    :label="label"
    placeholder="Search organizations"
    disable_group_text
    optional
    :dialog_only="dialog_only"
    ref="my-ctrl"
/>

</template>

<script>
const device = require('@/js/device.js');

export default {
    props: {
        value: {
            type: [Object, String],
            default: function() { return null; },
        },
        
        label: {
            type: String,
            default: function() { return "Organization Name"; },
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; },
        },

        dialog_only: {
            type: Boolean,
            default: function() { return false; },
        },

        'return-object' : {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            internal_value: null,
            items: [],
            search: null,
            is_loading: false, 
        }
    },

    mounted () {
        this.setInternalValue(this.value);
        if ( this.value == null )
            this.doSearch('');
    },

    methods: {
        onInput(val) {

            if ( val == null )
            {
                this.$emit('input', null);
                this.internal_value = null;
                this.search = null;
                return;
            }

            if ( this['return-object'] )
            {
                this.$emit('input', val);
            }
            else
            {
                this.$emit('input', val.value);
            }

            this.internal_value = val;
        },

        showDialog()
        {
            this.$refs['my-ctrl'].showDialog();
        },

        passAllItems(item, queryText, itemText)
        {
            return true;
        },

        doSearch(val)
        {
            this.is_loading = true;

            let search = {
                full_text: val,
            };

            this.$rc.searchOrganizationLabels(

                search,

                (data) => {
                    this.is_loading = false;

                    this.items = data.results;

                    for ( let i = 0; i < this.items.length; i++ )
                    {
                        this.items[i].text = this.items[i].label;
                        this.items[i].value = this.items[i].organization_id;
                    }
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }
            );
        },

        autocompleteMenuProps() {
            return device.autocompleteMenuProps();
        },

        setInternalValue(val)
        {
            if ( val == null )
            {
                this.items = null;
                this.internal_value = null;
                this.search = null;
                return;
            }

            else if ( typeof val === 'string' )
            {
                // assume the type is an organization id...

                this.is_loading = true;

                this.$rc.searchOrganizationLabels(

                    { 'organization_id' : val },

                    (data) => {
                        this.is_loading = false;

                        this.items = data.results;

                        for ( let i = 0; i < this.items.length; i++ )
                        {
                            this.items[i].text = this.items[i].label;
                            this.items[i].value = this.items[i].organization_id;
                        }

                        if ( this.items.length == 0 )
                        {
                            this.internal_value = null;
                            this.search = null;
                            return;
                        }
                        else
                        {
                            this.internal_value = this.items[0];
                            this.search = this.items[0].text;
                        }
                    },

                    () => {
                        this.is_loading = false;
                        this.items = [];
                    }

                );
            }

            else 
            {
                this.items=[val];
                this.internal_value = this.items[0];
                this.search = this.internal_value.text;
            }
        }
    },

    watch: {
        value(val) {
            this.setInternalValue(val);
        },

        search(val) {
            this.doSearch(val);
        }
    },
}

</script>

<style lang="scss" scoped>

</style>